export default {"src":"/_next/static/image/public/images/ic_tick_green.fe70eca640f1839454069ad0aa0a5bb4.svg","height":17,"width":17};